<template>
  <div>
    <v-row class="mb-1">
      <v-col cols="12">
        <h3 class="font-weight-bold">
          {{ translation(translationList.offer_type, 'Tip oferta') }}
        </h3>
        <p class="font-weight-regular">
          {{
            translation(translationList.offer_type_helper, 'Alege tipul de oferta pentru care doresti cotatie.')
          }}
        </p>
      </v-col>
    </v-row>
    <div
        class="border-0 px-0 py-0 d-inline-flex w-100"
        v-if="offerTypeList && offerTypeList.length"
    >
      <div
          v-for="(offerType, index) in offerTypeList"
          :key="index"
          class="w-100"
      >
        <div
            class="px-5 py-2 cursor-pointer w-100 text-center border"
            :class="offerType.id === selectedOfferType?.id ? 'bg-primary' : 'bg-primary-light'"
            @click="onTabChange(offerType)"
        >
          {{ offerType.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted} from 'vue';
import {translation, useTranslationStore} from '~/plugins/store/translations';
import {type OfferType} from '~/types/House';
import {useHouseStore} from '~/plugins/store/house';
import type {TranslationList} from '~/types/Utils';

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => OfferType | null,
      default: false,
    },
  },
  setup(props, {emit}) {
    const selectedOfferType = ref<OfferType | null>(props.modelValue ?? null);
    const translationList = ref<TranslationList>({});
    const offerTypeList = ref<OfferType[]>([]);
    const houseStore = useHouseStore();
    const translationStore = useTranslationStore();

    const onTabChange = (newValue: OfferType) => {
      selectedOfferType.value = newValue;
      emit('update:modelValue', newValue);
    };

    watch(() => props.modelValue, (newValue) => {
      selectedOfferType.value = newValue;
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      offerTypeList.value = await houseStore.getOfferTypeList();
    });

    return {
      selectedOfferType,
      onTabChange,
      translationList,
      translation,
      offerTypeList
    };
  },
});
</script>

<style scoped>
</style>